import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cN from 'classnames';
import styles from './styles.module.scss';
// import { updateFilterItems } from '@utils/utils';
import { I_FilterItem } from '@Redux/search/interfaces';
import { IcommonProps } from 'src/Interface';
// import CheckboxItem from './CheckboxItem';
import More from '@lion-design/icons'; //要測試是不是這種引入會把所有icon都引入
import Check2 from '@lion-design/icons'; //要測試是不是這種引入會把所有icon都引入
import { Checkbox } from '@lion-design/core';
import * as ShowMore from '@components/Common/ShowMore';
import BubbleBox from '@components/Common/BubbleBox';

interface I_MutiData extends IcommonProps {
    ParentTitle: string;
    ParentId: string;
    values: {
        ChildTitle: string;
        values: any;
        ParentID: string | number;
    }[];
}
// interface I_MutiData {
//     ParentTitle: string;
//     ParentId: string;
//     values: {
//         ChildTitle: string;
//         values: any;
//         ParentID: string | number;
//     }[];
// }

interface FilterBlockProps {
    data_cy?: string;
    multiData: I_MutiData;
    // multiData: I_MutiData[];
    // CityLength?: { [key: string]: number };
    destinationCount: number; //城市上限值
    checkBoxSelected: any[];
    reduxSelectedKey: string;
    whichStore: (payload: any) => { type: string; payload: any };
    openToggle?: boolean; // toggle是否開啟，傳給parentbox
    lightboxKeyword?: string; // 目的地的光箱關鍵字篩選變色用
    isDisabled?: boolean;
}
// 複選的keyName可能也要傳下來，或是object.key判斷

interface I_PatentCheckBox extends I_MutiData {
    checkBoxSelected: any[];
    reduxSelectedKey: string;
    whichStore: (payload: any) => { type: string; payload: any };
    openToggle?: boolean;
    ParentId: string;
    // clickedParentId: string;
    keyword?: string;
    setIsParentChecked: (val: boolean) => void;
    setShowListNum: (val: boolean) => void;
    isDisabled?: boolean;
    showListNum: boolean;
    destinationCount: number;
}

function buildTitle(title: string, keyword: string | undefined) {
    if (typeof keyword === 'undefined') return title;
    const reg = new RegExp(keyword, 'gi'); // 這裡可能要判斷關鍵字英文大小寫視為相同
    const copyTitle = title.replace(
        //符合關鍵字國家或城市名包進span
        reg,
        `<span style="color:#F03742">${keyword}</span>`
    );

    return <p dangerouslySetInnerHTML={{ __html: copyTitle }} />;
}

const ParentCheckBox: React.FC<I_PatentCheckBox> = ({
    ParentTitle,
    values,
    ParentId,
    children,
    checkBoxSelected,
    whichStore,
    reduxSelectedKey,
    openToggle, //光箱關鍵字用
    isDisabled,
    keyword,
    setIsParentChecked,
    setShowListNum,
    showListNum,
    destinationCount,
}) => {
    const dispatch = useDispatch();
    const sameType = checkBoxSelected.filter((item: I_FilterItem) => item.parentId === ParentId);
    const isParentclick = checkBoxSelected.findIndex(
        (item: I_FilterItem) => item.value === ParentId
    );
    const isparentdisabled = isDisabled && sameType.length === 0; //父層為disabled狀況為已達勾選上限，且子層未勾

    const handleParentCheckbox = () => {
        // e.stopPropagation(); //防止外層的顯示較多觸發
        if (isparentdisabled) return;
        const hasSameType = checkBoxSelected.findIndex(
            (item: I_FilterItem) => item.parentId === ParentId
        );
        setIsParentChecked(hasSameType > -1 ? false : true);
        // if (isDisabled && hasSameType < 0) return; // isDisabled從源頭props去查邏輯，如果為true則把未勾選的父層都return
        const diffFilterItems = checkBoxSelected.filter(
            (item: I_FilterItem) => item.parentId !== ParentId
        );
        // 篩選陣列裡有相同父層類別->刪除，沒有相同類別 -> 子層選項的值都放入篩選陣列
        if (hasSameType > -1) {
            return dispatch(
                whichStore({
                    [reduxSelectedKey]: diffFilterItems,
                    Page: 1,
                    PageSize: 10,
                })
            );
        }
    };
    const subListLength = values.filter((item) => item.ChildTitle !== ''); //子資料會有城市空值，但國家有值狀況
    const isSubListAllClicked = useMemo(() => {
        //全選顯示勾勾，非全選顯示+號
        if (sameType.length === 0) return null;
        // selected相同的父層id 長度是否跟傳入的資料長度相同，或是value跟parentId相同=>國家全選的意思
        if (sameType.length === subListLength.length || isParentclick > -1)
            return <Check2 type="check2" />;

        return <More type="more" fill="#f03742" />;
    }, [checkBoxSelected]);
    useEffect(() => {
        if (
            // 如果只有國家有值，但城市沒有值時
            (sameType.length === subListLength.length && subListLength.length !== 0) ||
            isParentclick > -1
        ) {
            return setIsParentChecked(true);
        }
        setIsParentChecked(false);
    }, [isSubListAllClicked]);
    useEffect(() => {
        if (sameType.length === 0 && Boolean(openToggle) === false) return setShowListNum(false); // redux store裡面沒有同一類的父層不展開
        if (sameType.length > 0) return setShowListNum(true); // redux store裡面至少有一個同類父層、點擊的父層title相同則展開
    }, []);
    useEffect(() => {
        setShowListNum(Boolean(openToggle));
    }, [openToggle]);

    return (
        <div className={cN(styles.Block_title)}>
            <BubbleBox content="已達選取上限" showBubble={destinationCount >= 200}>
                <div className={styles.customCheckBox} onClick={handleParentCheckbox}>
                    <div
                        className={styles.checkbox}
                        style={{ background: isparentdisabled ? '#f1f1f1' : '' }}
                    >
                        {isSubListAllClicked}
                        <input
                            className={cN(styles.parentCheckbox)}
                            type="radio"
                            disabled={isparentdisabled}
                        />
                    </div>
                    <label htmlFor="">{buildTitle(ParentTitle, keyword)}</label>
                </div>
            </BubbleBox>
            <ShowMore.OnlyArraw
                show={showListNum}
                handleShowList={() => setShowListNum(!showListNum)}
            />
        </div>
    );
};

const MultiCheckbox: React.FC<FilterBlockProps> = (props) => {
    const moduleName = 'MultiCheckbox';
    const {
        multiData,
        checkBoxSelected,
        reduxSelectedKey,
        whichStore,
        lightboxKeyword,
        isDisabled, //城市勾選是否上限
        destinationCount,
    } = props; // options 複選為obj測試資料

    const dispatch = useDispatch();
    const [isParentChecked, setIsParentChecked] = useState(false);
    const [showListNum, setShowListNum] = useState<boolean>(
        lightboxKeyword ? multiData.ParentTitle.indexOf(lightboxKeyword) >= -1 : false
    ); // 是否一開始就展開父層,由useEffect監聽狀態
    const handleSingleCheckbox =
        (Name: string, Id: string, ParentID: string) => (e: React.MouseEvent) => {
            e.stopPropagation();
            if ((isParentChecked || isDisabled) && reduxSelectedKey === 'selectedDestinationID')
                return; //父層勾選的話子層、城市已達上限都不做任何紀錄
            // setClickedParentId(ParentID);
            const hasChecked = checkBoxSelected.findIndex((item: I_FilterItem) => {
                return item.value === Id;
            });

            const selectedData = {
                filterBy: multiData.ParentTitle,
                subValue: '',
                text: Name,
                value: Id,
                parentId: multiData.ParentId,
            };
            if (hasChecked === -1) {
                dispatch(
                    whichStore({
                        [reduxSelectedKey]: [...checkBoxSelected, selectedData],
                        Page: 1,
                        PageSize: 10,
                    })
                );
                return;
            }

            const slicedDate = checkBoxSelected.filter((item: I_FilterItem) => {
                return item.value !== Id;
            });

            return dispatch(
                whichStore({
                    [reduxSelectedKey]: [...slicedDate],
                    Page: 1,
                    PageSize: 10,
                })
            );
        };

    useEffect(() => {
        if (isParentChecked) {
            //因票券的所有商品類別料不會紀錄父層，只有目的地有國家父層需紀錄
            const ParentCheckbox = {
                filterBy: multiData.ParentTitle,
                text: multiData.ParentTitle,
                value: multiData.ParentId,
                subValue: '',
                parentId: multiData.ParentId,
            };

            const diffCity = checkBoxSelected.filter((obj) => obj.parentId !== multiData.ParentId);

            const combineObj =
                reduxSelectedKey === 'selectedDestinationID'
                    ? [ParentCheckbox, ...multiData.values]
                    : multiData.values;

            dispatch(
                whichStore({
                    [reduxSelectedKey]: [...combineObj, ...diffCity], //關鍵處:紀錄時以全選的parentId 優先放在最前面，方便判斷全選、城市計算
                    Page: 1,
                    PageSize: 10,
                })
            );
        }
    }, [isParentChecked]);
    // const [clickedParentId, setClickedParentId] = useState('');
    return (
        <ul className={styles.filterBlocks} key={`${multiData.ParentId}`}>
            <li className={styles[`${moduleName}`]}>
                <ParentCheckBox
                    {...multiData}
                    checkBoxSelected={checkBoxSelected}
                    reduxSelectedKey={reduxSelectedKey}
                    whichStore={whichStore}
                    openToggle={
                        lightboxKeyword
                            ? multiData.ParentTitle.indexOf(lightboxKeyword) >= -1
                            : false
                    }
                    setShowListNum={setShowListNum}
                    showListNum={showListNum}
                    isDisabled={isDisabled}
                    keyword={lightboxKeyword}
                    setIsParentChecked={setIsParentChecked}
                    destinationCount={destinationCount}
                />
                {showListNum && (
                    <div className={cN(styles.mt_15, styles.mb_15)}>
                        <ul className={cN(styles.CheckBoxes)}>
                            {multiData.values.map((opt: any) => {
                                if (opt.values === '' || opt.values === opt.ParentID) return null; //空值或是紀錄用的國家id不顯示
                                const isDisable =
                                    (isParentChecked || isDisabled) &&
                                    reduxSelectedKey === 'selectedDestinationID';
                                const childCheckboxProps = {
                                    title: buildTitle(opt.ChildTitle, lightboxKeyword),
                                    disabled: isDisable, //只有目的地會有disabled功能
                                    checkFillColor: isDisable ? '#bbb' : '#f03742',
                                    checkedBackgroundColor: 'transparent',
                                    checked:
                                        isParentChecked ||
                                        checkBoxSelected.findIndex(
                                            (item: I_FilterItem) =>
                                                item.value == opt.values ||
                                                item.value === opt.ParentID
                                        ) > -1,
                                };
                                // return showListNum ? () : null;
                                return (
                                    <li
                                        className={cN(
                                            styles.CheckBoxWrap,
                                            isDisable ? styles.disabled : ''
                                        )}
                                        onClick={handleSingleCheckbox(
                                            opt.ChildTitle,
                                            opt.values,
                                            opt.ParentID
                                        )}
                                        key={opt.values}
                                    >
                                        <BubbleBox
                                            content="已達選取上限"
                                            showBubble={destinationCount >= 200}
                                        >
                                            <Checkbox {...childCheckboxProps} />
                                        </BubbleBox>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </li>
        </ul>
    );
};
export default MultiCheckbox;
